var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var videos = [];
var youTubeInitializedSl= false;

function onYouTubeIframeAPIReady() {

    var numOfVideos = $('.home-half-slider .video-container').length;
    
    if (numOfVideos < 1)
        return;

    $('.home-half-slider .video-slide').each(function (index) {
        videos[index] = new YT.Player($(this).find('.video').attr('id'), {
            height: '100%',
            width: '100%',
            host: 'https://www.youtube.com',
            videoId: $(this).find('.video').data('video-code'),
            playerVars: {
                rel: '0',
                controls: '0',
                showinfo: '0'
            }
        });
        youTubeInitializedSl = true;
    });

}

function pauseVideo() {
    for (var i = 0; i < videos.length; i++) {
        if (typeof videos[i].pauseVideo == 'function') {
            videos[i].pauseVideo();
        }
    }
}

Vendd.Scripts.load(function () {

    if ($('.home-half-slider > ul > li').length < 2)
        return;

    initOwlSlider($('.home-half-slider > ul'), {
        singleItem: true,
        autoPlay: false,
        rewindSpeed: 1500,
        stopOnHover: true,
        autoHeight: true,
        transitionStyle: "fade",
        afterMove: function () {
            if (youTubeInitializedSl)
                pauseVideo();
        }
    });

});
